<template>
  <main class="pkg">
    <header class="hero" style="height: 1.36rem;">
      <div style="width:3.75rem;margin:0 auto;position:relative;height:1.36rem;">
        <div class="hero-bg" aria-hidden="true"></div>
        <img class="hero-top-title" src="./static/images/package/liuliangtaocan.png" alt="流量套餐">
        <div class="hero-card-title" aria-hidden="true">基础套餐</div>
      </div>
    </header>
    <section class="content">
      <section class="cards" aria-label="套餐列表">
        <article
          class="card"
          :class="{ 'card--hot': packageID === item.id }"
          aria-label="套餐卡片"
          v-for="item in packages0"
          :key="item.id"
          @click="checkPackage(item)"
        >
          <h2 class="card-title">{{ item.title }}</h2>
          <p class="card-price"><span class="price-symbol">¥</span><span class="price-num">{{ item.price }}</span></p>
          <div class="card-meta">
            <p class="card-desc">{{ item.typeName }}</p>
          </div>
          <button class="card-btn" type="button" @click.stop="checkPackage(item);createOrder()">立即订购</button>
        </article>
      </section>

      <section class="notice" aria-label="购买须知" v-if="tipsText">
        <h3 class="notice-title">购买须知</h3>
        <p class="notice-body">{{ tipsText }}</p>
      </section>
    </section>

    <footer class="sticky">
      <label class="agree">
        <input v-model="agreed" class="agree-check" type="checkbox">
        <span class="agreement-text">已阅读并同意<a href="javascript:;" class="agreement-link" @click.stop.prevent="openAgreement">《用户服务协议》</a></span>
      </label>
    </footer>

    <van-popup v-model="showAgreement" position="bottom" round class="agreement-popup">
      <div class="agreement-panel">
        <div class="agreement-header">
          <span>用户服务协议</span>
          <button type="button" class="agreement-close" @click="showAgreement=false">关闭</button>
        </div>
        <div class="agreement-body" v-if="agreementLoading">
          <van-loading size="22px" color="#1989fa" />
          <p>协议加载中...</p>
        </div>
        <div class="agreement-body agreement-content" v-else>
          <p v-for="(line, idx) in agreementLines" :key="idx">{{ line }}</p>
        </div>
      </div>
    </van-popup>
  </main>
</template>

<script>
export default {
  name: "rechargeNew",
  data () {
    return {
      iccid: "",
      packageID: 0,
      packageGroup: [],
      one: {},
      stockInfo: {},
      tips: [],
      operator: {},
      authRecharge: 0,
      type: 0,
      agreed: true,
      showAgreement: false,
      agreementLoading: false,
      agreementLines: []
    }
  },
  computed: {
    packages0 () { return this.packageGroup[0] || [] },
    tipsText () { return this.tips.join("\n") }
  },
  methods: {
    queryPackageList (type) {
      this.$toast.loading()
      this.fetchData("/package/getRechargePackage", { iccid: this.iccid, type }, (res) => {
        this.$toast.clear()
        const packageList = res.code ? res.data : []
        this.$set(this.packageGroup, type, packageList)
        if (type === 0 && packageList.length && !this.packageID) {
          this.checkPackage(packageList[0])
        }
      })
    },
    checkPackage (item) { this.packageID = item.id; this.one = item },
    createOrder () {
      if (!this.agreed) return this.$toast("请先勾选并同意《用户服务协议》")
      if (this.authRecharge === 0) return this.$toast("请实名后再续费,若已实名，请尝试刷新网页重试")
      if (this.type === 0 && this.one.alertMsg) {
        this.$dialog.confirm({ title: "提示", message: this.one.alertMsg }).then(() => {
          this.stockInfo.rechargeType === 1 ? this.commitorderbalance() : this.commitorder()
        })
        return
      }
      this.stockInfo.rechargeType === 1 ? this.commitorderbalance() : this.commitorder()
    },
    commitorder () {
      this.$toast.loading({ forbidClick: true })
      this.fetchDataPost("/order/createOrder", { iccid: this.iccid, packageID: this.packageID, type: this.type }, (res) => {
        this.$toast.clear()
        if (res.code) {
          window.WeixinJSBridge.invoke("getBrandWCPayRequest", res.data, (payRes) => {
            if (payRes.err_msg === "get_brand_wcpay_request:ok") {
              this.$toast.success("支付成功")
              this.$router.push({ name: "index", query: { iccid: this.iccid } })
            }
          })
          return
        }
        if (res.url) {
          if (res.msg) {
            this.$dialog.confirm({ title: "提示", message: res.msg }).then(() => {
              const query = res.data || {}
              query.cardno = this.iccid
              sessionStorage.removeItem("token")
              this.$router.push({ path: res.url, query })
            })
          } else {
            this.$router.push({ path: res.url, query: res.data })
          }
          return
        }
        this.$dialog.alert({ title: "提示", message: res.msg })
      })
    },
    commitorderbalance () {
      this.$toast.loading({ forbidClick: true })
      this.fetchDataPost("/order/createOrderbalance", { iccid: this.iccid, packageID: this.packageID, type: this.type }, (res) => {
        this.$toast.clear()
        if (res.code) {
          this.$toast.success(res.msg)
          setTimeout(() => this.$router.back(), 1500)
        } else {
          this.$toast(res.msg)
          if (res.msg && res.msg.indexOf("积分") !== -1) setTimeout(() => this.rechargeBalance(), 1500)
        }
      })
    },
    rechargeBalance () { this.$router.push({ name: "cardBalance", query: { iccid: this.iccid } }) },
    getStockInfo () {
      this.fetchData("/card/info", { iccid: this.iccid }, (res) => {
        this.stockInfo = res.data || {}
        if (this.stockInfo.amount > 0) this.type = 1
      })
    },
    getTips () {
      this.fetchData("/card/tips", { iccid: this.iccid }, (res) => {
        this.tips = ((res.data || "") + "").split("\n")
      })
    },
    openAgreement () {
      this.showAgreement = true
      if (this.agreementLines.length) return
      this.agreementLoading = true
      fetch("/static/service-agreement.txt", { cache: "no-store" })
        .then((res) => res.text())
        .then((txt) => {
          this.agreementLines = txt.split(/\r?\n/).map((line) => line.trim()).filter((line) => line)
        })
        .catch(() => {
          this.agreementLines = ["协议内容加载失败，请稍后重试。"]
        })
        .then(() => {
          this.agreementLoading = false
        })
    },
    getCardOperator () {
      this.fetchData("/card/cardOperator", { iccid: this.iccid }, (res) => {
        if (!res.code) return
        this.operator = res.data
        if (this.operator.activeRule === 1) {
          this.fetchData("/card/status", { iccid: this.iccid }, (statusRes) => {
            if (!statusRes.data.simAuthStatus) {
              this.$dialog.alert({ title: "实名提示", message: "请先完成实名" }).then(() => { window.location.href = this.operator.authUrl })
            } else {
              this.authRecharge = 1
            }
          })
        } else {
          this.authRecharge = 1
        }
      })
    }
  },
  created () {
    this.iccid = this.$route.query.iccid
    this.getStockInfo()
    this.getCardOperator()
    this.queryPackageList(0)
    this.getTips()
  }
}
</script>

<style scoped src="./static/css/package.css"></style>
<style scoped>
.pkg {
  --bg: #fff;
  --heroDark: #26324f;
  --blue1: #8052fd;
  --blue2: #3d78f8;
  --blue: #249cf7;
  --text: #0c0c0c;
  --muted: rgba(12, 12, 12, 0.7);
  --cardBorder: #d1d3d5;
  --hot: #f1b96b;
  --hotText: #754e19;
}

.agreement-link {
  color: #fff;
  text-decoration: none;
  font-weight: 500;
}

.agreement-popup {
  max-height: 80vh;
}

.agreement-panel {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  background: #fff;
}

.agreement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .16rem;
  border-bottom: 1px solid #f0f0f0;
  font-size: .16rem;
  font-weight: 600;
  color: #1f2a44;
}

.agreement-close {
  border: none;
  background: transparent;
  color: #1989fa;
  font-size: .14rem;
}

.agreement-body {
  padding: .14rem .16rem .2rem;
  overflow-y: auto;
  font-size: .13rem;
  line-height: 1.7;
  color: #333;
}

.agreement-content p {
  margin: 0 0 .08rem;
}

.cards {
  gap: .08rem;
}

.content {
  padding: .12rem .16rem .14rem;
}

.card {
  border-radius: .08rem;
  border: 1px solid #d1d3d5;
  background: #fff;
  box-shadow: none;
  padding: .08rem .08rem .07rem;
  min-height: 1.03rem;
}

.card--hot {
  border-color: #f1b96b !important;
  background: rgb(254, 248, 240) !important;
}

.card-title {
  color: #111;
  font-size: .12rem;
  font-weight: 500;
  line-height: .17rem;
}

.card-price {
  margin-top: .02rem;
  display: flex;
  align-items: baseline;
  justify-content: center;
  color: #111;
}

.price-symbol {
  font-size: .11rem;
  margin-right: .02rem;
}

.price-num {
  font-size: .22rem;
  line-height: .32rem;
  font-weight: 500;
}

.card-meta {
  margin-top: .02rem;
  min-height: .22rem;
}

.card-desc {
  margin-top: 0;
  color: #111;
  font-size: .11rem;
  line-height: .16rem;
}

.card-date {
  margin-top: .08rem;
  color: #666;
  font-size: .1rem;
  font-weight: 400;
  display: none;
}

.card-btn {
  margin-top: .06rem;
  width: .94rem;
  height: .25rem;
  border-radius: .08rem;
  background: #249CF7;
  font-size: .12rem;
  font-weight: 500;
  line-height: .25rem;
  padding: 0;
}

.sticky {
  background: #249CF7;
  border: 0;
  box-shadow: none;
  border-radius: .08rem;
  padding: .12rem .14rem;
}

.agree {
  align-items: center;
  justify-content: center;
  gap: .08rem;
  color: #fff;
  line-height: 1;
}

.agree-check {
  margin-top: 0;
  flex-shrink: 0;
  width: .14rem;
  height: .14rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, .9);
  background: transparent;
}

.agree-check::after {
  width: .06rem;
  height: .06rem;
  border: 0;
  border-radius: 50%;
  background: #fff;
  transform: none;
}

.agreement-text {
  font-size: .12rem;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/newpage/recharge.vue